import { render, staticRenderFns } from "./wtr-profile.vue?vue&type=template&id=23aa8561&scoped=true&"
import script from "./wtr-profile.vue?vue&type=script&lang=js&"
export * from "./wtr-profile.vue?vue&type=script&lang=js&"
import style0 from "./wtr-profile.vue?vue&type=style&index=0&id=23aa8561&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa8561",
  null
  
)

export default component.exports